module.exports = __webpack_public_path__ + "static/media/use_esim_en5.0e23e885.png";